<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        <ion-icon
          slot="icon-only"
          name="close"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Reciprocal Charge</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-list lines="none">
    <ion-item>
      <ion-label position="stacked">Venue</ion-label>
      <ion-select
        [(ngModel)]="selectedVenueId"
        placeholder="Select venue"
      >
        <ion-select-option
          *ngFor="let opt of reciprocalVenueOptions"
          [value]="opt.id"
        >
          {{ opt.name }}
        </ion-select-option>
      </ion-select>
    </ion-item>
    <ion-item>
      <ion-label position="stacked">Member Name</ion-label>
      <ion-input
        [(ngModel)]="memberName"
        type="text"
        placeholder="Enter member name"
      ></ion-input>
    </ion-item>
    <ion-item>
      <ion-label position="stacked">Member Number</ion-label>
      <ion-input
        [(ngModel)]="memberNumber"
        type="text"
        placeholder="Enter member number"
      ></ion-input>
    </ion-item>
  </ion-list>
</ion-content>

<ion-footer>
  <ion-row class="footer-row">
    <ion-col>
      <ion-button
        expand="block"
        color="danger"
        (click)="cancel()"
        >Cancel</ion-button
      >
    </ion-col>
    <ion-col>
      <ion-button
        expand="block"
        color="secondary"
        [disabled]="!selectedVenueId || !memberName?.trim() || !memberNumber?.trim()"
        (click)="confirm()"
        >Continue</ion-button
      >
    </ion-col>
  </ion-row>
</ion-footer>
